<template>
  <div class="body">
    <Header/>
    <Top/>
    <Concept/>
    <Sns/>
    <Menu/>
    <!-- <Suggestion/> -->
    <!-- <Rosette/> -->
    <Attention/>
    <Owner/>
    <Contact/>
    <Footer/>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from '@/components/Header.vue'
import Top from '@/components/Top.vue'
import Concept from '@/components/main/Concept.vue'
import Sns from '@/components/main/Sns.vue'
import Menu from '@/components/main/Menu.vue'
// import Suggestion from '@/components/main/Suggestion.vue'
// import Rosette from '@/components/main/Rosette.vue'
import Attention from '@/components/main/Attention.vue'
import Owner from '@/components/main/Owner.vue'
import Contact from '@/components/main/Contact.vue'
import Footer from '@/components/Footer.vue'


export default {
  name: 'body',
  data(){
    return {
      isIntersecting: false,
    }
  },
  components: {
    Header,
    Top,
    Concept,
    Sns,
    Menu,
    // Suggestion,
    // Rosette,
    Attention,
    Owner,
    Contact,
    Footer,
  },
  methods: {
    onIntersect (entries) {
      this.isIntersecting = entries[0].isIntersecting
    },
  },
}
</script>

<style lang="scss">
.fade {
  animation: fadeIn 2s ease-in-out 0s;
}
.none {
  display: none;
}
.section-title {
  letter-spacing: -1em;
}
.expandTitle {
  transition: 1s;
  color: $accent-color;
  letter-spacing: 0.1em;
}

.strongFont {
  color: $main-color;
  letter-spacing: 0.4rem;
}



  // #scrollArea {
  //   position: fixed;
  //   z-index: 1;
  //   top: 15%;
  //   width: 100%;
  //   height: 70%;
  //   // background: transparent;
  //   // background: gray;
  //   border: 1px solid;
  // }
</style>